/* LUVA "Notify me at launch" modal (added 2026-10-16). See snippets/luva-notify.liquid.
   The form posts natively so Shopify's own bot protection (hCaptcha) can run; after the
   post Shopify reloads the page with ?customer_posted=true#LuvaNotifyForm and the modal
   re-opens with the success message rendered by Liquid. */
(function () {
  'use strict';
  var modal = document.querySelector('[data-luva-nm]');
  if (!modal) return;
  var form = modal.querySelector('#LuvaNotifyForm, form');
  var fields = modal.querySelector('[data-luva-nm-fields]');
  var ok = modal.querySelector('[data-luva-nm-ok]');
  var email = modal.querySelector('[data-luva-nm-email]');
  var go = modal.querySelector('[data-luva-nm-go]');
  var err = modal.querySelector('[data-luva-nm-err]');
  var tags = modal.querySelector('[data-luva-nm-tags]');
  var lastFocus = null;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var KEY = 'luvaNmTags';

  function setTag(trigger) {
    if (!tags || !trigger) return;
    var h = trigger.getAttribute('data-luva-notify-product');
    if (!h) {
      var holder = trigger.closest && trigger.closest('[data-product-handle]');
      if (holder) h = holder.getAttribute('data-product-handle');
    }
    if (h) tags.value = tags.getAttribute('data-base') + ',notify-' + h.toLowerCase().replace(/[^a-z0-9-]+/g, '-');
  }

  function resetState() {
    ok.hidden = true;
    ok.removeAttribute('data-posted');
    fields.hidden = false;
    err.hidden = true;
  }

  function open(trigger) {
    lastFocus = document.activeElement;
    setTag(trigger);
    modal.hidden = false;
    document.documentElement.classList.add('luva-nm-lock');
    if (!ok.hidden) { var d = ok.querySelector('button'); if (d) d.focus({ preventScroll: true }); return; }
    setTimeout(function () { try { email.focus({ preventScroll: true }); } catch (e) { email.focus(); } }, 60);
  }

  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('luva-nm-lock');
    if (!ok.hidden) resetState();
    if (/^#(luva-notify|LuvaNotifyForm)$/.test(location.hash) && history.replaceState) {
      history.replaceState(null, '', location.pathname + location.search.replace(/[?&]customer_posted=true/, '').replace(/^&/, '?'));
    }
    if (go) { go.disabled = false; go.removeAttribute('aria-busy'); }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  window.LuvaNotify = { open: open, close: close };

  /* Capture phase: runs before the older scroll-to-footer handlers and stops them. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el) return;
    var t = el.closest('[data-luva-notify], [data-luva-notify-cta], a[href="#luva-notify"]');
    if (t && !modal.contains(t)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open(t);
      return;
    }
    if (el.closest('[data-luva-nm-close]') && modal.contains(el)) {
      e.preventDefault();
      close();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!modal.hidden && (e.key === 'Escape' || e.key === 'Esc')) close();
  });

  email.addEventListener('input', function () { err.hidden = true; email.removeAttribute('aria-invalid'); });

  form.addEventListener('submit', function (e) {
    var v = (email.value || '').trim();
    email.value = v;
    if (!EMAIL_RE.test(v)) {
      e.preventDefault();
      err.textContent = err.getAttribute('data-invalid');
      err.hidden = false;
      email.setAttribute('aria-invalid', 'true');
      email.focus();
      return;
    }
    /* Valid: let the native post (and Shopify's captcha) run. */
    try { sessionStorage.setItem(KEY, String(Date.now())); } catch (x) {}
    go.setAttribute('aria-busy', 'true');
    go.textContent = go.getAttribute('data-busy') || go.textContent;
    try { if (window.dataLayer) window.dataLayer.push({ event: 'luva_launch_notify_submit' }); } catch (x) {}
    setTimeout(function () { go.removeAttribute('aria-busy'); go.textContent = go.getAttribute('data-label') || go.textContent; }, 8000);
  });

  /* Coming back from the post: only react when it was this form (hash), not the footer. */
  var pending = 0;
  try { pending = parseInt(sessionStorage.getItem(KEY) || '0', 10); sessionStorage.removeItem(KEY); } catch (x) {}
  var mine = /^#(luva-notify|LuvaNotifyForm)$/.test(location.hash) || (pending && Date.now() - pending < 15 * 60 * 1000);
  if (ok.hasAttribute('data-posted') || !err.hidden) {
    if (mine) {
      open(null);
      try { if (ok.hasAttribute('data-posted') && window.dataLayer) window.dataLayer.push({ event: 'luva_launch_notify_signup' }); } catch (x) {}
    } else {
      resetState();
    }
  } else if (location.hash === '#luva-notify') {
    open(null);
  }
})();
